import { z } from "zod";

/** Every tool the agent has, in the order the editor lists them. */
export const TOOL_NAMES = [
	"search_products",
	"get_product",
	"find_ingredients",
	"add_to_basket",
	"update_basket",
	"set_substitution",
	"clear_basket",
	"get_basket",
	"get_order_status",
	"escalate_to_human",
	/** WhatsApp: the branch for a named area or store (tools-whatsapp.ts). */
	"set_store",
	/** WhatsApp only: the shopper's own stop or resume for offers. */
	"set_marketing_consent",
	"start_checkout",
	"reorder",
	"cancel_order",
	"report_order_issue",
	/** Calls only: the assistant hangs up once the caller is done. */
	"end_call",
] as const;
export type ToolName = (typeof TOOL_NAMES)[number];

/** The tools that existed before a configuration recorded which ones it was saved with. */
const FIRST_TOOLS: readonly string[] = [
	"search_products",
	"get_product",
	"find_ingredients",
	"add_to_basket",
	"update_basket",
	"clear_basket",
	"get_basket",
	"escalate_to_human",
];

/**
 * A saved configuration lists the tools it enables, so a tool added later would stay off for
 * every retailer until someone switched it on. `known` records the tools a configuration was
 * saved with: one it has never seen starts enabled, one it saw and left out stays off.
 */
export const toolsSchema = z
	.object({
		enabled: z.array(z.enum(TOOL_NAMES)).default([...TOOL_NAMES]),
		known: z.array(z.string()).default([...FIRST_TOOLS]),
	})
	.prefault({})
	.transform(({ enabled, known }) => ({
		enabled: TOOL_NAMES.filter(
			(name) => enabled.includes(name) || !known.includes(name),
		),
		known: [...TOOL_NAMES] as string[],
	}));
